// A stable per-browser device identifier (BP 23 attendance "known device" rule;
// BP 26 auth-event logging). Persisted in localStorage so it survives reloads;
// every read/write is wrapped in try/catch and falls back to an in-memory id
// for the current tab when localStorage is unavailable (private browsing,
// blocked site data, a sandboxed preview, …) — never let a storage error break
// the caller.
const STORAGE_KEY = 'acechem-device';

let sessionFallback: string | null = null;

function newId(): string {
  return crypto.randomUUID();
}

export function getDeviceId(): string {
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const id = newId();
    window.localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    if (!sessionFallback) sessionFallback = newId();
    return sessionFallback;
  }
}
